import { useNavigate } from 'react-router'
import { ChevronLeft } from '@mui/icons-material'
import { IconButton } from '@mui/material'

const BackButton = () => {
  const navigate = useNavigate()

  return (
    <IconButton color="inherit" onClick={() => navigate(-1)} aria-label="Go back">
      <ChevronLeft />
    </IconButton>
  )
}

export default BackButton
